"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInstanceValues = setInstanceValues;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Deeply copies values from a couple sources to an instance of a class
 * Works on strings, numbers, objects, arrays of strings and/or numbers
 *
 * @param instanceValues: the instance of a class where the values are to be applied
 * @param sourceValues: any values other than default to apply
 * @param defaultValues: default values when incoming values are missing
 */
function setValues(instanceValues, sourceValues, defaultValues) {
  for (var prop in defaultValues) {
    if (Array.isArray(defaultValues[prop])) {
      instanceValues[prop] = sourceValues[prop] && Array.isArray(sourceValues[prop]) ? _toConsumableArray(sourceValues[prop]) : [];
    } else if (_typeof(defaultValues[prop]) === "object") {
      instanceValues[prop] = setValues({}, sourceValues[prop] || {}, defaultValues[prop]);
    } else {
      instanceValues[prop] = !!sourceValues[prop] || sourceValues === false ? sourceValues[prop] : defaultValues[prop];
    }
  }
  return instanceValues;
}

/**
 * Sets the values for an instance of a class.
 * Context must be bound to the instance before using this function.
 *
 * @param sourceValues: any values other than default to apply
 * @param defaultInstance: default values when incoming values are missing
 */
function setInstanceValues(sourceValues) {
  var defaultInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getDefaultInstance();
  Object.assign(this, setValues({}, sourceValues, defaultInstance));
}